/**
 * Funktion zum Kopieren von Objekten
 * @param value
 */
export function deepCopy(value) {
  return JSON.parse(JSON.stringify(value));
}
